/*
 * wc-cart.js
 * Shared cart helper for Wooded V2.
 *
 * - Every add-to-cart flow (Dawn <product-form>, upsells)
 *   feeds into the same counter-update + toast path.
 * - Dawn fires PUB_SUB_EVENTS.cartUpdate from product-form.js and cart.js;
 *   WCCart subscribes so those still work without each caller repeating logic.
 * - Custom fetches call WCCart.add() directly for immediate UI feedback.
 */
(function () {
  var TOAST_VISIBLE_MS = 4000;
  var TOAST_FADE_MS = 300;
  var toastHideTimer = null;
  var toastRemoveTimer = null;

  function updateCount(n) {
    var value = String(n);
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = value;
    });
  }

  function showToast(message, opts) {
    opts = opts || {};
    var toast = document.getElementById('wc-cart-toast');
    if (!toast) return;

    var msgEl = toast.querySelector('[data-cart-toast-message]');
    var linkEl = toast.querySelector('[data-cart-toast-link]');
    if (msgEl) msgEl.textContent = message || 'Added to cart';
    if (linkEl) {
      var showLink = opts.showLink !== false;
      linkEl.hidden = !showLink;
      if (showLink) linkEl.href = opts.href || '/cart';
    }

    if (toast.dataset.variant) toast.classList.remove('wc-cart-toast--' + toast.dataset.variant);
    var variant = opts.variant || 'success';
    toast.classList.add('wc-cart-toast--' + variant);
    toast.dataset.variant = variant;

    toast.hidden = false;
    // Force a reflow so the transition plays on every show.
    void toast.offsetWidth;
    toast.classList.add('is-visible');

    if (toastHideTimer) clearTimeout(toastHideTimer);
    if (toastRemoveTimer) clearTimeout(toastRemoveTimer);
    toastHideTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
      toastRemoveTimer = setTimeout(function () { toast.hidden = true; }, TOAST_FADE_MS);
    }, TOAST_VISIBLE_MS);
  }

  function refreshCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') updateCount(cart.item_count);
        return cart;
      });
  }

  function normalizeItems(payload) {
    if (Array.isArray(payload)) return payload;
    if (payload && Array.isArray(payload.items)) return payload.items;
    if (payload && payload.id) return [payload];
    return [];
  }

  function add(payload) {
    var items = normalizeItems(payload);
    if (!items.length) {
      return Promise.reject(new Error('WCCart.add: no items'));
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        return res.json().then(function (body) {
          return { ok: res.ok, status: res.status, body: body };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          var msg = (result.body && (result.body.description || result.body.message)) || 'Could not add to cart.';
          var err = new Error(msg);
          err.body = result.body;
          err.status = result.status;
          throw err;
        }
        return refreshCount().then(function (cart) {
          showToast('Added to cart', { href: '/cart', showLink: true, variant: 'success' });
          // Dawn's pubsub.js / constants.js declare these as top-level function/const in
          // classic scripts — they're reachable as bare identifiers, NOT via window.*.
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'wc-cart',
              cartData: cart
            });
          }
          return { ok: true, body: result.body, cart: cart };
        });
      });
  }

  function onReady() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source === 'wc-cart') return; // already handled synchronously
      refreshCount().then(function () {
        if (event.source === 'cart-items') return; // qty change on /cart — no toast
        showToast('Added to cart', { href: '/cart', showLink: true, variant: 'success' });
      });
    });

    if (typeof PUB_SUB_EVENTS.cartError !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartError, function (event) {
        if (!event) return;
        var msg = event.message || (typeof event.errors === 'string' ? event.errors : 'Could not add to cart.');
        showToast(msg, { showLink: false, variant: 'error' });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  window.WCCart = {
    add: add,
    updateCount: updateCount,
    showToast: showToast,
    refresh: refreshCount
  };
})();
